import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import Welcome from '../views/home/Welcome.vue'

// 动态导入页面组件
const BannerManagement = () => import('../views/home/BannerManagement.vue')
const CategoryManagement = () => import('../views/home/CategoryManagement.vue')
const UserManagement = () => import('../views/home/UserManagement.vue')
const ProductManagement = () => import('../views/home/ProductManagement.vue')
const OrderManagement = () => import('../views/home/OrderManagement.vue')
const OrderAddonManagement = () => import('../views/home/OrderAddonManagement.vue')
const CustomerServiceManagement = () => import('../views/home/CustomerServiceManagement.vue')
const DiyMaterialManagement = () => import('../views/home/DiyMaterialManagement.vue')
const DesignPlazaManagement = () => import('../views/home/DesignPlazaManagement.vue')
const DesignerManagement = () => import('../views/home/DesignerManagement.vue')
const HomePosterManagement = () => import('../views/home/HomePosterManagement.vue')
const HomeNoticeManagement = () => import('../views/home/HomeNoticeManagement.vue')
const DiyStudioManagement = () => import('../views/home/DiyStudioManagement.vue')
const AdminProfile = () => import('../views/home/AdminProfile.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    redirect: '/home/welcome',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'welcome',
        name: 'Welcome',
        component: Welcome,
        meta: { requiresAuth: true }
      },
      {
        path: 'banner',
        name: 'BannerManagement',
        component: BannerManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'category',
        name: 'CategoryManagement',
        component: CategoryManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'user',
        name: 'UserManagement',
        component: UserManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'product',
        name: 'ProductManagement',
        component: ProductManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'order',
        name: 'OrderManagement',
        component: OrderManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'order-addon',
        name: 'OrderAddonManagement',
        component: OrderAddonManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'customer-service',
        name: 'CustomerServiceManagement',
        component: CustomerServiceManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'diy-material',
        name: 'DiyMaterialManagement',
        component: DiyMaterialManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'design-plaza',
        name: 'DesignPlazaManagement',
        component: DesignPlazaManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'designer',
        name: 'DesignerManagement',
        component: DesignerManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'poster',
        name: 'HomePosterManagement',
        component: HomePosterManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'notice',
        name: 'HomeNoticeManagement',
        component: HomeNoticeManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'music',
        name: 'HomeMusicManagement',
        component: () => import('../views/home/HomeMusicManagement.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'diy-studio',
        name: 'DiyStudioManagement',
        component: DiyStudioManagement,
        meta: { requiresAuth: true }
      },
      {
        path: 'profile',
        name: 'AdminProfile',
        component: AdminProfile,
        meta: { requiresAuth: true }
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.meta.requiresAuth && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router
